import { NextParsedUrlQuery } from 'next/dist/server/request-meta'

export interface Query extends NextParsedUrlQuery {
  fullscreen?: string
  withCloseButton?: string
  white_logo?: string
  day?: string
  rid?: string
  lang?: string
  srid?: string
  pax?: string
  mini?: string
  pid?: string | string[]
  prescriber_id?: string
  trackable_id?: string
  trackable_source?: string
  type?: string
  hidelang?: string
  colorMode?: string
  primaryColor?: string
  pixelid?: string
  'source-rid'?: string
  waiting_list?: string
  room_id?: string
  firstname?: string
  lastname?: string
  'force-prepayment'?: string
  'force-imprint'?: string
  token?: string
  cmp?: string
  redirectResult?: string
  showCollapsed?: string
  iframePosition?: 'left' | 'center' | 'right'
  shxpid?: string
  setup_intent?: string
  setup_intent_client_secret?: string
  buuid?: string // EBM flow
  booking_uuid?: string // payment flow
  timestamp?: string
}

/**
 * Interface representing query parameters for Google Reserve integration.
 *
 * @interface GoogleReserveQueryParams
 * @property {string} timestamp - Unix timestamp format, containing the day and time of the reservation.
 * @property {string} pax - The number of guests. Corresponds to the number of guests in the Zenchef system.
 * @property {string} [room] - Optional. Corresponds to the room id in the Zenchef system.
 */
export interface GoogleReserveQueryParams extends Query {
  timestamp: string
  pax: string
  room_id?: string
  rwg_token: string
}

export interface GoogleReserveParams {
  timestamp: number
  pax: number
  room_id: number | null
}

export interface GoogleReserveParamsAndToken extends GoogleReserveParams {
  rwg_token: string | null
}

export const isGoogleReserveQuery = (query: Query): query is GoogleReserveQueryParams => {
  return typeof query.timestamp === 'string' && typeof query.pax === 'string'
}

export const parseGoogleReserveParams = (query: GoogleReserveQueryParams): GoogleReserveParamsAndToken => {
  try {
    return {
      timestamp: Number(query.timestamp),
      pax: Number(query.pax),
      room_id: query.room_id ? Number(query.room_id) : null,
      rwg_token: query.rwg_token ? String(query.rwg_token) : null
    }
  } catch (error) {
    throw new Error('Invalid Google Reserve query parameters: ' + error.message)
  }
}
